export const LOGIN_SUCCESS = "login_success";
export const LOGOUT = "LOGOUT";
export const LOADER = "loader";
export const SET_SELECTED_ROLE = "set_selected_role";
export const SET_SELECTED_FORM_ID = "set_selected_form_id";
export const GET_DEPARTMENT_FORM_SUCCESS = "get_department_form_success";   
export const IS_ANSWERED = "is_answers";   
export const SET_MAIN_FLOW_ID = "set_main_flow_id";
export const SET_VIEW_ANNOUNCEMENT = "set_view_announement";
export const SET_SELECTED_FLOW_ID = "set_selected_flow_id";
export const SET_SUB_TICKET_ID = "set_sub_ticket_id";
export const USERMODALS = "USERMODALS";
export const SET_FORM_BUILDER_VALUES = 'SET_FORM_BUILDER_VALUES';
export const GROUPMODALS = 'GROUPMODALS';
export const SETGROUPLIST = "SETGROUPLIST";
export const IS_EDIT = 'is_edit';
export const MEMBERMODAL = 'MEMBERMODAL';


export const SET_FORM_BUILDER_MODE = 'SET_FORM_BUILDER_MODE';
export const SET_CREATE_FORM_GROUP_LIST = 'SET_CREATE_FORM_GROUP_LIST';
export const SET_CONFIGURATION_LIST = 'SET_CONFIGURATION_LIST';
export const SET_FILTER_LIST='SET_FILTER_LIST';
export const SET_DATA_TYPE='SET_DATA_TYPE';
export const SET_JOB_SCHEDULE="SET_JOB_SCHEDULE"
export const SET_PROVISION_TYPE='SET_PROVISION_TYPE';

// automation projects actions types
export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';

//Action Type for Jobs creation and Fetch

export const FETCH_JOBS_REQUEST = 'FETCH_JOBS_REQUEST';
export const FETCH_JOBS_SUCCESS = 'FETCH_JOBS_SUCCESS';
export const FETCH_JOBS_FAILURE = 'FETCH_JOBS_FAILURE';

export const CREATE_JOB_REQUEST = 'CREATE_JOB_REQUEST';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const CREATE_JOB_FAILURE = 'CREATE_JOB_FAILURE';

export const RUN_JOB_REQUEST = 'RUN_JOB_REQUEST';
export const RUN_JOB_SUCCESS = 'RUN_JOB_SUCCESS';
export const RUN_JOB_FAILURE = 'RUN_JOB_FAILURE';

export const UPDATE_JOB_CONFIG_REQUEST = 'UPDATE_JOB_CONFIG_REQUEST';
export const UPDATE_JOB_CONFIG_SUCCESS = 'UPDATE_JOB_CONFIG_SUCCESS';
export const UPDATE_JOB_CONFIG_FAILURE = 'UPDATE_JOB_CONFIG_FAILURE';

export const FETCH_JOB_LOGS_REQUEST = "FETCH_JOB_LOGS_REQUEST";
export const FETCH_JOB_LOGS_SUCCESS = "FETCH_JOB_LOGS_SUCCESS";
export const FETCH_JOB_LOGS_FAILURE = "FETCH_JOB_LOGS_FAILURE";
export const CLEAR_JOB_LOGS = "CLEAR_JOB_LOGS";
export const FETCH_JOB_LOGS_BY_GROUP_SUCCESS = 'FETCH_JOB_LOGS_BY_GROUP_SUCCESS';
export const FETCH_JOB_LOGS_BY_GROUP_FAILURE = 'FETCH_JOB_LOGS_BY_GROUP_FAILURE';




